<div class="home-workspace">
  <div class="main-container">
    <span style="font-size: 32px">
      Welcome to {{ domainService.getAppName() }} Power BI report
      viewer</span
    >
  </div>
</div>
